import { render, staticRenderFns } from "./UserSidebar.vue?vue&type=template&id=789c20cf&scoped=true"
import script from "./UserSidebar.vue?vue&type=script&lang=js"
export * from "./UserSidebar.vue?vue&type=script&lang=js"
import style0 from "./UserSidebar.vue?vue&type=style&index=0&id=789c20cf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789c20cf",
  null
  
)

export default component.exports